import staticStrings from './staticStrings.json'

export const CLIP_SOURCE_TYPE = {
  ACTIVITY: 'Activity',
  CONCEPT_FEEDBACK: 'ConceptFeedback',
  EVIDENCE_ACTIVITY: 'Evidence::Activity',
  EVIDENCE_PASSAGE: 'Evidence::Passage',
  EVIDENCE_PROMPT: 'Evidence::Prompt',
  QUESTION: 'Question',
  STATIC_STRING: 'StaticString',
  TITLE_CARD: 'TitleCard',
} as const

export type ClipSourceType = typeof CLIP_SOURCE_TYPE[keyof typeof CLIP_SOURCE_TYPE]

export const CONCEPT_FEEDBACK_TYPE = {
  CONNECT: 'connect',
  FILL_IN_BLANK: 'fill-in-blank',
  GRAMMAR: 'grammar',
} as const

export type StaticStringKey = keyof typeof staticStrings

export interface ClipSource {
  id: string;
  type: ClipSourceType;
}

export interface SpeechRequest {
  source?: ClipSource | null;
  text: string;
}

const STATIC_STRING_KEY_SEPARATOR = '.'
const CONCEPT_FEEDBACK_ID_SEPARATOR = '/'
const PLACEHOLDER = /\{\w+\}/

export const clipSource = (type: ClipSourceType, id: string | number | null | undefined): ClipSource | null => (id === null || id === undefined || id === '' ? null : { id: String(id), type, })

export const staticStringSource = (key: StaticStringKey, ...values: Array<string | number>): ClipSource => ({ id: [key, ...values].join(STATIC_STRING_KEY_SEPARATOR), type: CLIP_SOURCE_TYPE.STATIC_STRING, })

export const fillStaticString = (key: StaticStringKey, values: Record<string, string | number>): string => staticStrings[key].replace(/\{(\w+)\}/g, (_match, name) => String(values[name]))

export const conceptFeedbackSource = (activityType: string | undefined, uid: string | null | undefined): ClipSource | null => (activityType && uid ? { id: [activityType, uid].join(CONCEPT_FEEDBACK_ID_SEPARATOR), type: CLIP_SOURCE_TYPE.CONCEPT_FEEDBACK, } : null)

let keysByText: Map<string, StaticStringKey> | null = null

const staticStringKeys = () => {
  if (keysByText === null) {
    const index = new Map<string, StaticStringKey>()
    Object.entries(staticStrings).forEach(([key, text]) => {
      if (!PLACEHOLDER.test(text) && !index.has(text)) { index.set(text, key as StaticStringKey) }
    })
    keysByText = index
  }
  return keysByText
}

export const staticStringSourceFor = (text: string): ClipSource | null => {
  const key = staticStringKeys().get(text)
  return key === undefined ? null : staticStringSource(key)
}
